import { keyframes } from '@emotion/react'
import { Box, Flex, Heading, Icon, Image, Text } from '@chakra-ui/react'
import { Helmet } from 'react-helmet'
import { FiSettings } from 'react-icons/fi'
import logo from 'src/Images/logo_black.png'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const spinReverse = keyframes`
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
`

const progress = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
`

const Maintenance = () => (
  <>
    <Helmet>
      <title>Under Maintenance | Langistan</title>
    </Helmet>
    <Flex
      minH="100vh"
      direction="column"
      align="center"
      justify="center"
      textAlign="center"
      bg="#F4F7FE"
      px={4}
    >
      <Image
        src={logo}
        alt="Langistan"
        h={{ base: '36px', md: '48px' }}
        mb={{ base: 10, md: 12 }}
      />

      <Box
        position="relative"
        w={{ base: '110px', md: '140px' }}
        h={{ base: '100px', md: '125px' }}
        mb={{ base: 8, md: 10 }}
      >
        <Icon
          as={FiSettings}
          position="absolute"
          top="0"
          left="0"
          boxSize={{ base: '72px', md: '92px' }}
          color="#2469F5"
          animation={`${spin} 8s linear infinite`}
        />
        <Icon
          as={FiSettings}
          position="absolute"
          bottom="0"
          right="0"
          boxSize={{ base: '44px', md: '56px' }}
          color="#168AFF"
          animation={`${spinReverse} 6s linear infinite`}
        />
      </Box>

      <Heading
        as="h1"
        fontSize={{ base: '2xl', md: '4xl' }}
        color="gray.800"
        mb={3}
      >
        This site is under maintenance
      </Heading>
      <Text fontSize={{ base: 'md', md: 'xl' }} color="gray.600" mb={8}>
        We will be back soon.
      </Text>

      <Box
        w="100%"
        maxW="360px"
        h="6px"
        bg="#DCE6FB"
        borderRadius="full"
        overflow="hidden"
      >
        <Box
          h="100%"
          w="40%"
          borderRadius="full"
          bg="linear-gradient(90deg, #168AFF 0%, #2469F5 100%)"
          animation={`${progress} 1.6s ease-in-out infinite`}
        />
      </Box>
    </Flex>
  </>
)

export default Maintenance
